	import $ from 'jquery';
    import _ from 'underscore';
    import Backbone from "backbone";
    import Base64 from 'Base64';

    const getSafeLocalStorage = function(){
        try {
            return window.localStorage;
        } catch (error) {
            return null;
        }
    };

    const safeStorageSetItem = function(storage, key, value){
        if(!storage){
            return false;
        }
        try{
            storage.setItem(key, value);
            return true;
        }catch(error){
            return false;
        }
    };

    const safeStorageGetItem = function(storage, key){
        if(!storage){
            return null;
        }
        try{
            return storage.getItem(key);
        }catch(error){
            return null;
        }
    };

    const TrebbleLocalStorageModel = Backbone.Model.extend({
    
        //list of all key present in local storage
        "default" : {
            "usernameKey" : "trebbleUserName",
            "passwordKey" : "trebblePassword",
            
        },

        initialize : function() {

        },

        saveUsername : function(usernameToSave){
            const storage = getSafeLocalStorage();
            safeStorageSetItem(storage, this.get("usernameKey"), usernameToSave);
        },
        
        
        /*savePassword : function(passwordToSave){
        const encodedPasswordToSave =  Base64.encode(passwordToSave);
            window.localStorage.setItem(this.get("passwordKey"), encodedPasswordToSave);
        },*/
        
        retrieveUsername : function(){
            const storage = getSafeLocalStorage();
            return safeStorageGetItem(storage, this.get("usernameKey"));
        },
        
        
        savePassword : function(passwordToSave){
            const storage = getSafeLocalStorage();
            if(!storage){
                return null;
            }
            const encodedPasswordToSave = Base64.encode(passwordToSave);
            if(safeStorageSetItem(storage, this.get("passwordKey"), encodedPasswordToSave)){
                return encodedPasswordToSave;
            }
            return null;
        },
        retrievePassword : function(){
            const storage = getSafeLocalStorage();
            if(!storage){
                return null;
            }
            const encodedPasswordToSave = safeStorageGetItem(storage, this.get("passwordKey"));
            if(encodedPasswordToSave)
            {
                return Base64.decode(encodedPasswordToSave);
            }
            return null;
        },
        

    });

    const TrebbleLocalStorage = new TrebbleLocalStorageModel();

    export default {
        getInstance : function() {
            return TrebbleLocalStorage;
        }
    };
